/** What a cell shows for a missing value. A mark, not a word, so it needs no translation. */
export const BLANK = '—';

export function BlankValue() {
  return <span className="text-muted-foreground">{BLANK}</span>;
}
